import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0334a18d")

_pushScopeId("data-v-0334a18d")
const _hoisted_1 = { class: "container edit-item-lang-container" }
const _hoisted_2 = { class: "location-title" }
const _hoisted_3 = {
  key: 0,
  class: "edit-item-lang-content"
}
const _hoisted_4 = { class: "edit-item-filter" }
const _hoisted_5 = { class: "edit-item-filter-btn" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_7 = {
  key: 0,
  class: "add-item"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle pr-20" }, null, -1)
const _hoisted_9 = { class: "footer-locations" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EditLangItem = _resolveComponent("EditLangItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('title.' + _ctx.type)), 1),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _withDirectives(_createVNode("input", {
              type: "text",
              placeholder: _ctx.$t('placeholder.search-by-location', [_ctx.type == 'regions' ? _ctx.$t('region.text') : _ctx.$t('city.text')]),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter = $event)),
              onInput: _cache[2] || (_cache[2] = ($event: any) => {
            _ctx.debounce(() => {
              _ctx.SearchLocations();
            })
          })
            }, null, 40, ["placeholder"]), [
              [_vModelText, _ctx.filter]
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.SearchLocations()))
              }, [
                _hoisted_6
              ])
            ])
          ]),
          (!_ctx.itemToEdit || _ctx.itemToEdit.id)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _createVNode("button", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addItem()))
                }, [
                  _hoisted_8,
                  _createTextVNode(_toDisplayString(_ctx.$t('btn.add-new-location', [_ctx.type == 'regions' ? _ctx.$t('region.text') : _ctx.$t('city.text')])), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
            return (_openBlock(), _createBlock(_component_EditLangItem, {
              key: index,
              item: item,
              itemToEdit: _ctx.itemToEdit,
              index: index,
              onEditItem: _ctx.editItem,
              onRejectChanges: _ctx.rejectChanges,
              onApplyChanges: _ctx.applyChanges,
              onDeleteItem: _ctx.deleteItem,
              onEditLangs: _ctx.editLangs
            }, null, 8, ["item", "itemToEdit", "index", "onEditItem", "onRejectChanges", "onApplyChanges", "onDeleteItem", "onEditLangs"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_9, [
      _createVNode("button", {
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goBack()))
      }, _toDisplayString(_ctx.$t('button.close')), 1)
    ])
  ]))
})